import React from "react";
import { Wrapper, Inner, Text, Spinner } from "./styles/submitting-styles";
import spinner from "./img/loading.gif";

const Submitting = () => (
  <Wrapper className="animated fadeIn">
    <Inner>
      <Spinner src={spinner} alt="Submitting spinner" />
      <Text>Submitting...</Text>
    </Inner>
  </Wrapper>
);

export default Submitting;
